import MenuService from "../../core/components/menu/MenuService";
import MenuItem from "../../core/components/menu/MenuItem";
import i18n from './../../shared/i18n'
import LiveBids from "./LiveBids";
import StartSale from "./StartSale";

const routes = [
  {
    path: 'start-sale',
    name: 'startSale',
    component: StartSale,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'auction-console/sale/:saleNo',
    name: 'liveBids',
    component: LiveBids,
    meta: {
      requiresAuth: true
    }
  },
];

MenuService.addMenuItem(new MenuItem('/start-sale', i18n.t('Auction Console'), 4, 'gavel', [], 'auction_console'));

export {routes}
